import {
  mdiMessage,
  mdiBullhorn,
  mdiTagMultiple,
  mdiViewList,
  mdiCart,
  mdiAccount,
  mdiInbox,
  mdiChartLine,
  mdiHelp,
  mdiEye,
  mdiPencil,
  mdiAccountMultiple,
  mdiCalendar,
  mdiFilter,
  mdiSourceBranch,
  mdiCheck,
  mdiLogout,
  mdiCellphoneMessage,
  mdiChevronLeft,
  mdiAccountCircle,
  mdiDotsVertical,
  mdiAccountDetails,
  mdiAlarm,
  mdiTag,
  mdiShare,
  mdiExport,
  mdiMenu,
  mdiPlus,
  mdiAccountGroup,
  mdiCommentMultiple,
  mdiCommentCheck,
  mdiTimerSand,
  mdiMessageText,
  mdiPause,
  mdiClose,
  mdiCancel,
  mdiDelete,
  mdiInformation,
  mdiCheckboxBlank,
  mdiCheckboxMarked,
  mdiRadioboxBlank,
  mdiRadioboxMarked,
  mdiChevronDown,
  mdiAlert,
  mdiAlertCircle,
  mdiCheckboxIntermediate,
  mdiArrowExpand,
  mdiLoading,
  mdiChevronRight,
  mdiArrowUp,
  mdiEmail,
  mdiLock,
  mdiEyeOff,
  mdiPlay,
  mdiCircleEditOutline,
  mdiPlusBoxMultiple,
  mdiLabel,
  mdiMagnify,
  mdiBullhornOutline,
  mdiLinkVariant,
  mdiWhatsapp,
  mdiHelpCircle,
  mdiRefresh,
  mdiViewDashboard,
  mdiRobot,
  mdiSelect,
  mdiDirectionsFork,
  mdiHelpBox,
  mdiMenuDown,
  mdiArrowRight,
  mdiCloseCircleOutline,
  mdiViewComfy,
  mdiPowerPlug,
  mdiContentSave,
  mdiArrowDown,
  mdiRoutes,
  mdiArrowAll,
  mdiResizeBottomRight,
  mdiFacebookMessenger,
  mdiPoundBox,
  mdiChatProcessingOutline,
  mdiChat,
} from '@mdi/js';

export const iconService = {
  mdiFacebookMessenger,
  mdiChevronDown,
  mdiViewDashboard,
  mdiHelpCircle,
  mdiWhatsapp,
  mdiLinkVariant,
  mdiBullhornOutline,
  mdiMagnify,
  mdiDelete,
  mdiLabel,
  mdiPlusBoxMultiple,
  mdiAlert,
  mdiAlertCircle,
  mdiPlay,
  mdiEyeOff,
  mdiLock,
  mdiEmail,
  mdiClose,
  mdiPause,
  mdiMessageText,
  mdiMessage,
  mdiBullhorn,
  mdiTagMultiple,
  mdiViewList,
  mdiCart,
  mdiAccount,
  mdiInbox,
  mdiChartLine,
  mdiHelp,
  mdiEye,
  mdiPencil,
  mdiAccountMultiple,
  mdiCalendar,
  mdiFilter,
  mdiSourceBranch,
  mdiCheck,
  mdiLogout,
  mdiCellphoneMessage,
  mdiChevronLeft,
  mdiAccountCircle,
  mdiDotsVertical,
  mdiAccountDetails,
  mdiAlarm,
  mdiTag,
  mdiShare,
  mdiExport,
  mdiMenu,
  mdiPlus,
  mdiAccountGroup,
  mdiCommentMultiple,
  mdiCommentCheck,
  mdiTimerSand,
  mdiRefresh,
  mdiRobot,
  mdiSelect,
  mdiDirectionsFork,
  mdiHelpBox,
  mdiMenuDown,
  mdiArrowRight,
  mdiCloseCircleOutline,
  mdiViewComfy,
  mdiPowerPlug,
  mdiContentSave,
  mdiRoutes,
  mdiArrowDown,
  mdiArrowUp,
  mdiArrowAll,
  mdiResizeBottomRight,
  mdiPoundBox,
  mdiChatProcessingOutline,
  mdiChat,
};

export const defaultIcons = {
  complete: mdiCheck,
  cancel: mdiCancel,
  close: mdiClose,
  delete: mdiDelete, // delete (e.g. v-chip close)
  clear: mdiClose,
  success: mdiCheck,
  info: mdiInformation,
  warning: mdiAlert,
  error: mdiAlertCircle,
  prev: mdiChevronLeft,
  next: mdiChevronRight,
  checkboxOn: mdiCheckboxMarked,
  checkboxOff: mdiCheckboxBlank,
  checkboxIndeterminate: mdiCheckboxIntermediate,
  delimiter: mdiDotsVertical, // for carousel
  sort: mdiArrowUp,
  expand: mdiArrowExpand,
  menu: mdiMenu,
  subgroup: '...',
  dropdown: mdiChevronDown,
  radioOn: mdiRadioboxMarked,
  radioOff: mdiRadioboxBlank,
  edit: mdiCircleEditOutline,
  ratingEmpty: '...',
  ratingFull: '...',
  ratingHalf: '...',
  loading: mdiLoading,
  first: '...',
  last: '...',
  unfold: '...',
  file: '...',
};
